import * as React from 'react';
import { getFilterCTX } from '../context/FilterProvider';
import { fuzzyFilter } from '../../../../utils';
import { useDebounce } from '../../../../utils/hooks';
export function useFilter(_a) {
    var filterKey = _a.filterKey, data = _a.data, _b = _a.delay, delay = _b === void 0 ? 500 : _b, _c = _a.options, options = _c === void 0 ? { leading: false, trailing: true } : _c;
    var filterCTX = getFilterCTX();
    var state = React.useContext(filterCTX);
    // Throw if hook is used outside of the provider
    if (state === undefined) {
        throw new Error('useFilter must be used within a FilterProvider');
    }
    var _d = useDebounce(state.query, delay, options), search = _d[0], setSearch = _d[1], signal = _d[2].signal;
    var setQuery = state.setQuery, filtered = state.filtered, setFiltered = state.setFiltered, status = state.status, source = state.source, setSource = state.setSource;
    // Set source data to context (if given).
    // NOTE: this is required on at least one `useFilter` calls
    // Other `useFilter` calls can pull source data from context
    React.useEffect(function () {
        if (data !== undefined) {
            setSource(data);
        }
    }, [data]);
    React.useEffect(function () {
        var trimmed = search.trim();
        setQuery(search);
        if (trimmed === '') {
            setFiltered([]);
        }
        else {
            setFiltered(fuzzyFilter(trimmed, filterKey, source));
        }
    }, [signal]);
    var clearQuery = React.useCallback(function () {
        setSearch('', { immediate: true });
    }, []);
    return {
        source: source,
        search: search,
        query: state.query,
        setQuery: setSearch,
        clearQuery: clearQuery,
        setSource: setSource,
        filtered: filtered,
        status: status
    };
}
//# sourceMappingURL=useFilter.js.map